import workspaceQuery from '../../queries/product/StockAdjustmentWorkspaceQuery.graphql';
import listQuery from '../../queries/product/StockAdjustmentListQuery.graphql';
import instanceQuery from '../../queries/product/StockAdjustmentQuery.graphql';
import defaultQuery from '../../queries/product/StockAdjustmentDefault.graphql';
import mutationQuery from '../../mutations/product/StockAdjustmentMutation.graphql';
import temporaryMutationQuery from '../../mutations/product/StockAdjustmentTemporaryMutation.graphql';
import fragment from '../../fragments/product/StockAdjustmentFragment.graphql';
import temporaryQuery from '../../queries/product/StockAdjustmentTempDefaultQuery.graphql';
import { ALLOW_ADD, ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const StockAdjustment: EntityType = {
  type: 'StockAdjustment',
  title: 'Stock Adjustments',
  formTitle: 'Stock Adjustment',
  formUrl: '/Products/StockControl/StockAdjustment/Details/',
  workspaceUrl: '/Products/StockControl/StockAdjustment/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporary: temporaryQuery,
  temporarySave: temporaryMutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'documentReference',
  },
  fragment,
  screenReference: 'PRODUCTS_STOCK_CONTROL_STOCK_ADJUSTMENTS',
  operations: ALLOW_ADD | ALLOW_VIEW,
};

export default StockAdjustment;
